import StarDivider from '../components/StarDivider';

export default function QuiSommesNousPage() {
  return (
    <div className="qui-page"><div className="info-card" style={{ marginBottom: 24 }}>
        <div className="info-card-tag">IDENTITÉ</div>
        <h3>Qui sommes-nous ?</h3>
        <div className="info-card-line" />
        <p>Apostolat d'évangélisation et d'action Catholique venant du grand courant Renouveau Charismatique, animé par l'Esprit Saint et consacré à la Divine Miséricorde.</p>
        <p>Le Ministère Catholique Miséricorde (MCM) est une œuvre d'évangélisation fondée dans l'esprit du Renouveau Charismatique Catholique. Notre mission est d'annoncer la Bonne Nouvelle de Jésus-Christ à travers la prière, l'enseignement et le témoignage.</p>
      </div>

      <div className="info-card" style={{ marginBottom: 24 }}>
        <div className="info-card-tag">FOI</div>
        <h3>Notre spiritualité</h3>
        <div className="info-card-line" />
        <p>Enracinés dans la dévotion à la Divine Miséricorde et à Sainte Faustine Kowalska, nous vivons l'Évangile avec ferveur, prière et charité fraternelle au service de tous.</p>
        <p>La Divine Miséricorde est au cœur de notre spiritualité. Nous croyons que Dieu est riche en miséricorde et que cette miséricorde est offerte à tous sans exception.</p>
      </div>

      <div className="info-card" style={{ marginBottom: 24 }}>
        <div className="info-card-tag">MISSION</div>
        <h3>Notre charisme</h3>
        <div className="info-card-line" />
        <p>Évangéliser, prier et servir. Portés par le charisme de la Miséricorde divine, nous annonçons l'amour infini de Dieu à toute âme en quête de lumière et de salut.</p>
        <p>Notre charisme se manifeste à travers les Semences Matinales, les Espaces Sainte Faustine, les Atmosphères de Victoire et le Trône de Grâces — autant de moments de rencontre avec Dieu.</p>
      </div>
    </div>
  );
}
